import Button from '@mui/material/Button';
import { SelectedArea } from '../../../models/SelectedArea';
import {useDispatch,useSelector} from 'react-redux'
import { getAreaFilterState } from '../../../redux/selectors/filterSelector';
import { FilterAction } from '../../../redux/states/filterState';
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './componentsStyle.css'
export type Props = {}

const AreaSwitcherComponent: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const areaFilter = useSelector(getAreaFilterState)
  const { t } = useTranslation();  

  return(
  <>
    <li role="tab">
      <Button 
        className="nav-link"
        component={NavLink}
        variant={areaFilter.selectedArea===SelectedArea.Europe?"contained":"outlined"} 
        to="EUROPE"
        size='small'
        onClick={ () => {
          dispatch(FilterAction.SetArea(SelectedArea.Europe))
        }}
      >
        Europe
      </Button>
    </li>

    <li role="tab">
      <Button 
        className="nav-link"
        component={NavLink}
        variant={areaFilter.selectedArea===SelectedArea.France?"contained":"outlined"} 
        to="FRANCE"
        size='small'
        onClick={ () => {
          dispatch(FilterAction.SetArea(SelectedArea.France))
        }}
      >
        France
      </Button>
    </li>

    <li role="tab">
      <Button
        className="nav-link"
        component={NavLink}
        variant={areaFilter.selectedArea===SelectedArea.Departments?"contained":"outlined"} 
        to="DEPARTMENTS"
        size='small'
        onClick={ () => {
          dispatch(FilterAction.SetArea(SelectedArea.Departments))
        }}
      >
        {t('departments')}
      </Button>
    </li>
  </>);
}

export default AreaSwitcherComponent